




















































import type { PropType } from 'vue';
import { defineComponent, computed } from '@nuxtjs/composition-api';
import TwicpicsImage from '~/components/atoms/TwicpicsImage/TwicpicsImage.vue';
import type { ThumbnailItem } from '~/types/components/ThumbnailCarousel/ThumbnailItem';
import ImgView from '~/components/atoms/ImgView/ImgView.vue';

export default defineComponent({
  name: 'ThumbnailCarouselItem',
  components: {
    TwicpicsImage,
    ImgView,
  },
  props: {
    item: {
      type: Object as PropType<ThumbnailItem>,
      required: true,
    },
    size: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const itemSize = computed(() => `${props.size}px`);
    const imageAlt = computed(() => props.item.alt || 'Image');
    return {
      itemSize,
      imageAlt,
      customClasses: 'bg-EXPONDO-primary absolute opacity-70 w-full h-full flex justify-center items-center',
      imageClasses: 'object-cover border border-EXPONDO-primary-10',
      iconClasses: 'text-EXPONDO-white text-4xl',
    };
  },
});

